// IBKR Flex broker connection API client.
//
// Talks to the Django DRF Flex contract landed in TRA-334 (backend repo).
// All requests go through axiosClient (see ./axiosClient.js), which
// prefixes the configured backend root with /api/v1 — every endpoint here
// therefore lives under /api/v1/ibkr/flex/.
//
// Contract notes (do not deviate without a corresponding backend change):
// - POST /connect/ body is exactly { flex_token, query_id, account_id?,
//   label?, flex_version? }. There is no `token` or `flex_query_id` field.
// - Every response (status/connect/test/sync) is a FLAT object: connected,
//   credentials_stored, connection_status, sync_status, masked account_id,
//   masked token, masked query_id, and last_* status/error/message fields.
//   The backend never echoes back raw credential values.
// - connection_status is one of: not_connected, untested, connected, error.
//   `connected` is only true once the backend has actually verified the
//   credentials via /test/ — saving credentials alone does not flip it.

import axiosClient from './axiosClient.js';

const FLEX_BASE = '/ibkr/flex';

export const getFlexStatus = async () => {
  const { data } = await axiosClient.get(`${FLEX_BASE}/status/`, { skipGlobalErrorHandler: true });
  return data;
};

export const connectFlexCredentials = async ({ flexToken, queryId, accountId, label, flexVersion } = {}) => {
  const body = { flex_token: flexToken, query_id: queryId };
  if (accountId) body.account_id = accountId;
  if (label) body.label = label;
  if (flexVersion) body.flex_version = flexVersion;
  const { data } = await axiosClient.post(`${FLEX_BASE}/connect/`, body, { skipGlobalErrorHandler: true });
  return data;
};

export const testFlexConnection = async () => {
  const { data } = await axiosClient.post(`${FLEX_BASE}/test/`, {}, { skipGlobalErrorHandler: true });
  return data;
};

export const syncFlexNow = async () => {
  const { data } = await axiosClient.post(`${FLEX_BASE}/sync/`, {}, { skipGlobalErrorHandler: true });
  return data;
};

export const deleteFlexConnection = async () => {
  const { data } = await axiosClient.delete(`${FLEX_BASE}/delete/`, { skipGlobalErrorHandler: true });
  return data;
};

export default {
  getFlexStatus,
  connectFlexCredentials,
  testFlexConnection,
  syncFlexNow,
  deleteFlexConnection,
};
